

















import { Component, Vue } from "vue-property-decorator";
import { Getter, Action } from "vuex-class";
import * as cg_user_types from "@/store/constants/cg_user_types";
import * as setting_types from "@/store/constants/setting_types";
import Container from "@/components/Container/Container.vue";
import NavBar from "@/components/NavBarNew/NavBar.vue";
import Scroller from "@/components/Scroller/Scroller.vue";
import CoinsTitle from "@/components/SkuTitle/CoinsTitle.vue";
import LimitedCoin from "@/components/CoinEntrance/limitCoins/limitCoins.vue";
import RegularCoin from "@/components/CoinEntrance/RegularCoin.vue";
import LuckyCoin from "@/components/CoinEntrance/LuckyCoin.vue";
import VipPackages from "@/components/CoinEntrance/VipPackages.vue";
import StoreTitle from "./StoreTitle/index.vue";

import { isIos } from "@/utils/lodash";
import * as cgConst from "@/api/cg/base/cg_const";
@Component({
  components: {
    Container,
    NavBar,

    Scroller,
    CoinsTitle,
    LimitedCoin,
    RegularCoin,
    VipPackages,
    StoreTitle,
    LuckyCoin
  }
})
export default class CoinsContainer extends Vue {
  @Getter(setting_types.GETTER_CLIENT_SETTINGS)
  private settingData: any;
  @Getter(cg_user_types.GETTER_COINS)
  private userCoins: any;
  @Action(setting_types.UPDATE_GX_SETTING_DATA)
  private updateCoinStoreSetting: any;

  private showBackUpRecommend: boolean | string = false;

  get isIOS() {
    return isIos();
  }

  private tabsArr: object[] = [
    {
      label: "Buy Coins",
      labelColor: "#5C75EC",
      imgUrl: require("@/assets/icons-file/tab/coin_store_title_icon.png")
    },
    {
      label: "Free Coins",
      labelColor: "#17C396",
      imgUrl: require("@/assets/icons-file/tab/free_coins_title_icon.png")
    }
  ];

  private goBack() {
    this.$router.go(-1);
  }

  private async created() {
    this.updateCoinStoreSetting(cgConst.TAB_COIN_STORE_KEYS);
  }
}
